/** Convert an array of objects into a dictionary indexed by obj.id
 *
 * @param data
 */
export const indexById = (data) => {
    const byId = {};
    if (!data) {
        // Short-circuit with empty dict if ajax didn't return valid json data
        return byId;
    }
    for (let i = 0, max = data.length; i < max; i++) {
        let cur = data[i];
        byId[cur.id] = cur;
    }
    return byId;
};

/** Function to be used in Array.sort() to order by date
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const compareCreatedAt = (a, b) => {
    if (a.created_at < b.created_at) { return -1; }
    if (a.created_at > b.created_at) { return 1; }
    return 0;
};

/** Function to be used in Array.sort() to order by order_weight
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const compareOrderWeight = (a, b) => {
    if (a.order_weight < b.order_weight) { return -1; }
    if (a.order_weight > b.order_weight) { return 1; }
    return 0;
};

export const compareStartTime = (a, b) => {
    if (a.start_time < b.start_time) { return -1; }
    if (a.start_time > b.start_time) { return 1; }
    return 0;
};

export const compareStartTimeUTC = (a, b) => {
    if (a.start_time_utc < b.start_time_utc) { return -1; }
    if (a.start_time_utc > b.start_time_utc) { return 1; }
    return 0;
};

export const compareAttendeeName = (a, b) => {
    let nameA = a.attendee_name.toUpperCase();
    let nameB = b.attendee_name.toUpperCase();
    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

export const compareSenderName = (a, b) => {
    let nameA = a.sender_name.toUpperCase();
    let nameB = b.sender_name.toUpperCase();
    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

export const compareBy = (key) => (a, b) => {
    let fieldA = a[key].toUpperCase();
    let fieldB = b[key].toUpperCase();
    if (fieldA < fieldB) { return -1; }
    if (fieldA > fieldB) { return 1; }
    return 0;
}

/** Sort based on last_name.
 * If last_name isn't set, fall back to attempting 'initial' and full_name fields.
 * Django API pre-calculates the 'initial' field based on the either last or first_name.
 *
 * @param a {object}
 * @param b {object}
 * @returns {number}
 */
export const compareLastName = (a, b) => {
    let nameA = '-';
    let nameB = '-';
    if (a.last_name) {
        nameA = a.last_name.toUpperCase();
    } else if (a.initial) {
        nameA = a.initial.toUpperCase();
    } else if (a.full_name) {
        nameA = a.full_name.toUpperCase();
    }
    if (b.last_name) {
        nameB = b.last_name.toUpperCase();
    } else if (b.initial) {
        nameB = b.initial.toUpperCase();
    } else if (b.full_name) {
        nameB = b.full_name.toUpperCase();
    }

    if (nameA < nameB) { return -1; }
    if (nameA > nameB) { return 1; }
    return 0;
};

/** Filter array and discard any items within that have a deleted_at value
 *
 * @param {Object[]} items
 * @returns {Object[]}
 */
export const filterLiveOnly = (items) => {
    return items.filter(item => ! item.deleted_at);
};


export const isDeleted = (item) => {
    if (!item) { return true; }

    if (Object.prototype.hasOwnProperty.call(item, 'deleted_at')) {
        if (item['deleted_at']) { return true; }
    }
    return false;
};


/* https://jonlabelle.com/snippets/view/javascript/calculate-mean-median-mode-and-range-in-javascript */
export function mode(numbers) {
    // as result can be bimodal or multi-modal,
    // the returned result is provided as an array
    // mode of [3, 5, 4, 4, 1, 1, 2, 3] = [1, 3, 4]
    var modes = [], count = [], i, number, maxIndex = 0;

    for (i = 0; i < numbers.length; i += 1) {
        number = numbers[i];
        count[number] = (count[number] || 0) + 1;
        if (count[number] > maxIndex) {
            maxIndex = count[number];
        }
    }

    for (i in count)
        //if (count.hasOwnProperty(i)) {
        if (Object.prototype.hasOwnProperty.call(count, i)) {
            if (count[i] === maxIndex) {
                modes.push(Number(i));
            }
        }

    return modes;
}

export const flattenAnswers = (answers) => {
    const flattened = {};
    if (!answers) { return flattened; }
    // console.log(answers);
    answers.forEach(function (answer) {
        flattened[answer.cfid] = answer.flat;
    });
    return flattened;
};

export const  mergeAll = (base, overlay, extra) => {
    // console.log("EXTRA", extra);
    return {
        ...overlay,
        ...base,
        ...extra
    }
};


// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
export const groupBy = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
        let key = obj[property]
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
};

// Custom groupBy that converts a string => dateObj => date for the grouping
export const groupByDate = (objectArray, property) => {
    return objectArray.reduce(function (acc, obj) {
        let key = new Date(obj[property]).getDate();
        if (!acc[key]) {
            acc[key] = []
        }
        acc[key].push(obj)
        return acc
    }, {})
};


// https://plainjs.com/javascript/ajax/serialize-form-data-into-an-array-46/
export const serializeFormToArray = (form) => {
    var field, l, s = [];
    if (typeof form == 'object' && form.nodeName == "FORM") {
        var len = form.elements.length;
        for (var i=0; i<len; i++) {
            field = form.elements[i];
            if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
                if (field.type == 'select-multiple') {
                    l = form.elements[i].options.length;
                    for (let j=0; j<l; j++) {
                        if(field.options[j].selected)
                            s[s.length] = { name: field.name, value: field.options[j].value };
                    }
                } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
                    s[s.length] = { name: field.name, value: field.value };
                }
            }
        }
    }
    //return s;
    // Convert it to a single dictionary/obj
    const out = {};
    s.forEach(function(elem) {
       out[elem.name] = elem.value;
    });
    return out;
};
